import apiFetch from '../apiFetch'

export default function (token, metadatoId, documentId) {
  return apiFetch({ endPoint: `metadato/ListItems?metadatoId=${metadatoId}&documentId=${documentId}`, method: 'GET', body: null, token: token })
}
